module.exports = __webpack_public_path__ + "img/video.0f59db2e.png";